import { render, staticRenderFns } from "./PurchasePlanDetail.vue?vue&type=template&id=60fcb424&scoped=true&"
import script from "./PurchasePlanDetail.vue?vue&type=script&lang=js&"
export * from "./PurchasePlanDetail.vue?vue&type=script&lang=js&"
import style0 from "./PurchasePlanDetail.vue?vue&type=style&index=0&id=60fcb424&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fcb424",
  null
  
)

export default component.exports